import { TableContainer } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "ListDataView";
var classes = {
    listDataView: "".concat(PREFIX),
    headersRow: "".concat(PREFIX, "-headersRow"),
    header: "".concat(PREFIX, "-header"),
    body: "".concat(PREFIX, "-body")
};
var StyledListDataView = styled(TableContainer)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            wordBreak: "break-word"
        },
        _b[theme.breakpoints.down("md")] = {
            wordBreak: "normal"
        },
        _b["& .".concat(classes.listDataView)] = {
            tableLayout: "auto"
        },
        _b["& .".concat(classes.header)] = {
            padding: 0,
            paddingRight: 1,
            paddingLeft: 1,
            cursor: "default",
            whiteSpace: "nowrap",
            maxWidth: "150px"
        },
        _b);
});

export { PREFIX, classes, StyledListDataView as default };
//# sourceMappingURL=index.styled.js.map
